/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Portal_TomorrowInputs */

const en_booking_portal_tomorrow = /** @type {(inputs: Booking_Portal_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tomorrow`)
};

const pl_booking_portal_tomorrow = /** @type {(inputs: Booking_Portal_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jutro`)
};

/**
* | output |
* | --- |
* | "Tomorrow" |
*
* @param {Booking_Portal_TomorrowInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const booking_portal_tomorrow = /** @type {((inputs?: Booking_Portal_TomorrowInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Portal_TomorrowInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_booking_portal_tomorrow(inputs)
	return en_booking_portal_tomorrow(inputs)
});